import Modal from 'developer_components/newModal';
import {isMobile} from 'methods/utils';

function SubscribeModalConfirm() {
    this._$element = Modal.createFromHTML(
        `${isMobile() ?
            `<div class="Modal-native__header">
                <div class="Modal-native__header-title">Добро пожаловать в клуб!</div>
                <div class="Modal-native__close"></div>
            </div>` : ''}
            <div class="Modal-native__content">
            <div class="Subscribe">
                <div class="Subscribe__container">
                    <div class="Subscribe__row-left">
                        <div class="Subscribe__title">Добро пожаловать в клуб!</div>
                        <div class="Subscribe__text-container">
                            <div class="Subscribe__subtitle">Не забудьте подтвердить<br> подписку!</div>
                            <div class="Subscribe__text">Мы отправили письмо на указанный почтовый ящик. Для подтверждения подписки перейдите по ссылке в письме. Если вы не нашли письмо, проверьте папку «Спам»</div>
                        </div>
                        <button class="Button Button--noborder Button--shaded-blue js-modalAccept js-modalClose">Хорошо</button>
                    </div>
                    <div class="Subscribe__row">
                        <div class="Subscribe__image"></div>
                    </div>
                </div>
            </div>
            ${!isMobile() ? '<div class="Modal-native__close"></div>' : ''}
        </div>
        ${isMobile() ?
            `<div class="Modal-native__footer">
                <button class="Button Button--noborder Button--shaded-blue js-modalAccept js-modalClose">Хорошо</button>
            </div>` : ''
        }`,
        {
            id: 'subscribe-modal-confirm',
        }
    );

    // событие при нажатии на "Ок/Хорошо"
    const $links = this._$element.querySelectorAll('.js-modalAccept');
    $links.forEach($link => {
        $link.addEventListener('click', e => {
            this.emit('accept');
        });
    });

    // наследование
    Modal.call(this, this._$element);
}

SubscribeModalConfirm.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: SubscribeModalConfirm,
        enumerable: false,
        writable: true,
    }
});

export default SubscribeModalConfirm;
